// extracted by mini-css-extract-plugin
export default {"errorSections":"OrgsCheck_errorSections__V9gXz","otherErrorsSection":"OrgsCheck_otherErrorsSection__OPJ3B","otherError":"OrgsCheck_otherError__5eC67"};